<template>
  <card>
    <list
      v-if="$store.state.user.sections['roles']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        {
          label: "Название роли",
          key: "name",
          type: "field",
        },
        {
          label: "Экраны",
          key: "sections",
          type: "selects",
          modal: "section",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_role",
      itemLink: "roles",
      setLink: "roles",
      columns: [
        {
          key: "name",
          title: "Название  роли",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "sections",
        //   object: "name",
        //   title: "Экраны",
        //   disableLink: true,
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
